import { Translations } from './en/index';

/**
 * Ripped from translate-js, since it doesn't expose them
 */
const interpolateRE = /{{\s*(\w+)\s*}}/g;
const pluralizationRules = {
  en: {
    pluralizeTo: 'count',
    getVariationIndex: function (count: number) {
      return 1 === count ? 0 : 1;
    },
  },
};
const locale: keyof typeof pluralizationRules = 'en';

const interpolate = (translationString: string, data: any) => {
  return data
    ? translationString.replace(interpolateRE, function (match, param) {
        return data.hasOwnProperty(param) ? data[param] : match;
      })
    : translationString;
};

const translatePlural = (variations: string[], data: any) => {
  var rule = pluralizationRules[locale];
  var dataKeys = Object.keys(data);
  var pluralizeKey = dataKeys.length === 1 ? dataKeys[0] : rule.pluralizeTo;
  var count = parseFloat(data[pluralizeKey]);

  if (isNaN(count)) {
    throw new Error(
      `Translation pluralization missing parameters for string ${variations}`
    );
  } else {
    return interpolate(variations[rule.getVariationIndex(count)], data);
  }
};
/** End */

const translate = (translation: string | string[], data: any = {}): string => {
  if (!translation) {
    throw new Error(`Cannot find translation for provided key`);
  }
  if (Array.isArray(translation)) {
    return translatePlural(translation, data);
  } else {
    return interpolate(translation, data);
  }
};

export default translate;
export { Translations };
